export default __webpack_public_path__ + "static/media/review-img-4.90673034.png";